// extracted by mini-css-extract-plugin
export default {"editIcon":"editIcon---w9qRk"};